"use strict";import{tag as r}from"../custom-tag.js";export function soundOnIcon({height:l=16,width:e=16,hidden:s=!1,title:t="Sound on"}={}){return r`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${e}
      height=${l}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${s?"true":"false"}"
      role="img"
      aria-label="${t}"
    >
      <mask
        id="sound-on_svg__mask0_6875_6548"
        width="19"
        height="20"
        x="3"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="m9.2 15.586 4 4V4.414L8.907 8.707 8.614 9H4.2v6h5zM13.2 3l1-1v20l-1-1-5-5h-5V8h5zm3.797 5-.797.935c.572.812.916 1.885.916 3.065s-.344 2.268-.916 3.065l.797.935c.75-1.057 1.203-2.468 1.203-4s-.452-2.942-1.203-4m2.203.935L19.997 8c.75 1.058 1.202 2.467 1.203 4 0 1.532-.453 2.943-1.203 4l-.797-.935c.571-.797.916-1.885.916-3.065s-.345-2.253-.916-3.065"
          clip-rule="evenodd"
        />
      </mask>
      <g mask="url(#sound-on_svg__mask0_6875_6548)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=soundOn.js.map
